module.exports = __webpack_public_path__ + "img/dsci0103.a2851b3d.jpg";